import { useState } from 'react';
import type { FormEvent } from 'react';
import { Typography } from './Typography';
import { Button } from './Button';
import { company } from '../content/site';
import styles from './ContactSection.module.css';
export function ContactSection() {
  const [draft, setDraft] = useState<string | null>(null);
  function prepare(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const body = `Здравствуйте!\n\nКомпания: ${data.get('company')}\nКонтактное лицо: ${data.get('name')}\nEmail: ${data.get('email')}\nТелефон: ${data.get('phone')}\n\nЗадача:\n${data.get('task')}`;
    setDraft(
      `mailto:${company.email}?subject=${encodeURIComponent('Запрос коммерческого предложения')}&body=${encodeURIComponent(body)}`,
    );
  }
  return (
    <section className={styles.section}>
      <div className={styles.info}>
        <Typography as="h2" variant="title">
          Расскажите о вашем проекте
        </Typography>
        <Typography tone="muted">
          Укажите объекты, ориентировочные сроки и объём работ. Эта информация поможет нам
          подготовить коммерческое предложение.
        </Typography>
        <div className={styles.detail}>
          <Typography variant="eyebrow" tone="muted">
            Email
          </Typography>
          <a className={styles.email} href={`mailto:${company.email}`}>
            <Typography variant="subheading">{company.email}</Typography>
          </a>
        </div>
        <div className={styles.detail}>
          <Typography variant="eyebrow" tone="muted">
            Адрес
          </Typography>
          <Typography>{company.address}</Typography>
        </div>
        <Button
          href="/documents/audit-vector-presentation.pdf"
          variant="ghost"
          download
          icon="download"
        >
          Скачать презентацию
        </Button>
      </div>
      <form className={styles.form} onSubmit={prepare} onChange={() => setDraft(null)}>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <div className={styles.field}>
            <Typography as="label" htmlFor="contact-company" variant="small">
              Компания
            </Typography>
            <input
              id="contact-company"
              name="company"
              autoComplete="organization"
              required
              maxLength={150}
            />
          </div>
          <div className={styles.field}>
            <Typography as="label" htmlFor="contact-name" variant="small">
              Контактное лицо
            </Typography>
            <input id="contact-name" name="name" autoComplete="name" required maxLength={150} />
          </div>
          <div className={styles.field}>
            <Typography as="label" htmlFor="contact-email" variant="small">
              Email
            </Typography>
            <input
              id="contact-email"
              name="email"
              type="email"
              autoComplete="email"
              required
              maxLength={150}
            />
          </div>
          <div className={styles.field}>
            <Typography as="label" htmlFor="contact-phone" variant="small">
              Телефон, если удобно
            </Typography>
            <input id="contact-phone" name="phone" type="tel" autoComplete="tel" maxLength={40} />
          </div>
        </div>
        <div className={styles.field}>
          <Typography as="label" htmlFor="contact-task" variant="small">
            Описание задачи
          </Typography>
          <textarea id="contact-task" name="task" required rows={5} maxLength={2500} />
        </div>
        <Button type="submit" fullWidth>
          Подготовить письмо
        </Button>
        <Typography variant="small" tone="muted">
          Форма подготовит письмо для отправки через вашу почтовую программу. Данные не отправляются
          автоматически.
        </Typography>
        {draft && (
          <div className={styles.draft} role="status">
            <Typography variant="small">
              Письмо подготовлено. Откройте его в почтовой программе и отправьте нам.
            </Typography>
            <Button href={draft} fullWidth>
              Открыть письмо
            </Button>
          </div>
        )}
      </form>
    </section>
  );
}
